import { render, staticRenderFns } from "./ListStatusOptionPage.vue?vue&type=template&id=0c61e0dd&"
import script from "./ListStatusOptionPage.vue?vue&type=script&lang=js&"
export * from "./ListStatusOptionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports